import * as Sentry from "@sentry/react";
import posthog from "posthog-js";

export function initSentry() {
	const dsn = import.meta.env.VITE_SENTRY_DSN;
	if (!dsn) return;
	if (Sentry.isInitialized()) return;

	Sentry.init({
		dsn,
		environment: import.meta.env.MODE,
		release: import.meta.env.VITE_GIT_SHA || undefined,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
			...(import.meta.env.VITE_POSTHOG_KEY
				? [
						posthog.sentryIntegration({
							organization: import.meta.env.VITE_SENTRY_ORG || undefined,
							projectId: import.meta.env.VITE_SENTRY_PROJECT_ID
								? Number(import.meta.env.VITE_SENTRY_PROJECT_ID)
								: undefined,
							severityAllowList: ["error", "fatal"],
						}),
					]
				: []),
		],
		tracesSampleRate: 0.1,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 1.0,
	});
}
